import { Component, effect, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserDetails } from '../../../auth0/models';
import { Auth0Store } from '../../../auth0/store';

import { KeyValuePipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component';
import { DotsLoaderComponent } from '../../../../shared/components/dots-loader/dots-loader.component';
import { ClickCursorDirective } from '../../../../shared/directives/click-cursor.directive';
import { emailDomainValidator } from '../../../auth0/utils/email-domain-blacklist';

import { SnakeCaseTitlePipe } from '../../../../shared-lazy/pipes/snakeCaseTitle.pipe';

@Component({
  selector: 'gnx-invite-member-popup',
  templateUrl: './invite-member-popup.component.html',
  styleUrls: ['./invite-member-popup.component.scss'],
  imports: [
    ClickCursorDirective,
    ReactiveFormsModule,
    MatTooltip,
    AvatarComponent,
    KeyValuePipe,
    DotsLoaderComponent,
    MatSelect,
    MatOption,
    SnakeCaseTitlePipe,
  ],
})
export class InviteMemberPopupComponent implements OnInit {
  private dialogReg = inject<MatDialogRef<InviteMemberPopupComponent>>(MatDialogRef);
  data = inject<UserDetails>(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);

  protected auth0Store = inject(Auth0Store);
  readonly USER_TYPE = { admin: 'Admin', member: 'Member' };
  searchForm: FormGroup;
  usersList: { email: string; admin: boolean; role?: string }[] = [];
  sendingInvitations: boolean;

  get showApplicativeRoles(): boolean {
    return this.data?.org_config?.userConfig?.rolesAndPermissionsConfig?.active ?? false;
  }

  constructor() {
    effect(() => {
      const inProgress = this.auth0Store.inviteUsersInProgress();
      if (inProgress && this.sendingInvitations) {
        this.onClose();
      }
    });
  }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      email: [
        '',
        [Validators.email, Validators.pattern(/^\S*[@]\S*[.]\S*$/), Validators.required, emailDomainValidator],
      ],
    });

    if (this.showApplicativeRoles) {
      this.auth0Store.getApplicativeRoles();
    }
  }

  onClose() {
    this.dialogReg.close();
  }

  onSendInvitations() {
    this.sendingInvitations = true;
    this.auth0Store.inviteUsers({
      emails: this.usersList.map((user) => ({ email: user.email, admin: user.admin, role: user.role })),
      fromPopup: true,
      fromSettings: true,
    });
  }

  addUserToList(tooltip) {
    if (!this.usersList.find((user) => user.email === this.searchForm.controls.email.value)) {
      this.usersList.push({ email: this.searchForm.controls.email.value, admin: false });
      this.searchForm.controls.email.setValue('');
    } else {
      tooltip.show();
    }
  }

  deleteMember(email: string) {
    this.usersList = this.usersList.filter((user) => user.email !== email);
  }
}
